import { z } from "zod";

const oauthFlowTypeValues = ["PasswordGrant", "ClientCredentialsGrant"] as const;

export const oauthFlowTypeSchema = z.enum(oauthFlowTypeValues);
